import { useTranslation } from "react-i18next";

import type { AgentStatus } from "@/api/types";
import { Badge } from "@/components/ui/badge";

interface Props {
  status: AgentStatus;
}

const VARIANT_BY_STATUS: Record<
  AgentStatus,
  "default" | "secondary" | "outline" | "destructive"
> = {
  draft: "outline",
  pending_approval: "secondary",
  published: "default",
  archived: "destructive",
};

export function AgentStatusBadge({ status }: Props) {
  const { t } = useTranslation("agents");
  return (
    <Badge variant={VARIANT_BY_STATUS[status]}>
      {t(`status.${status}`)}
    </Badge>
  );
}
